/* eslint-disable max-len */
export const mainSeo = {
  title:
    'PlanDi проектная экосистема для инженеров и заказчиков - заказать проект на PlanDi',
  description:
    'PlanDi - это экосистема,объединяющая в себе следующие сервисы: Онлайн-Офис, Фриланс и Работа, Проектный Маркет, Блог, которая дает возможность инженерам, архитекторам, проектировщикам, а также проектным компаниям работать и зарабатывать Онлайн.'
  // keywords: [
  //   'заказать проект',
  //   'где заказать проект',
  //   'заказать индивидуальный проект',
  //   'биржа проектировщиков',
  //   'фриланс биржа проектировщиков',
  //   'биржа инженеров',
  //   'биржа фриланса инженеров',
  //   'PlanDi Проектный маркет'
  // ]
}

export const mainSeoEn = {
  titleEn:
    'PlanDi design ecosystem for engineers and customers - order a project on PlanDi',
  descriptionEn:
    'PlanDi is an ecosystem that combines the following services: Online Office, Freelance and Work, Project Market, Blog, which allows engineers, architects, designers, and design companies to work and earn money Online.'
}
